module.exports = __webpack_public_path__ + "img/notify-info.24a7194e.svg";